// Синглтон состояния для данных оборудования
let cachedEquipment = null;
let isLoading = false;
let loadPromise = null;

export const equipmentState = {
    getData: () => cachedEquipment,
    setData: (data) => { cachedEquipment = data; },

    getLoading: () => isLoading,
    setLoading: (loading) => { isLoading = loading; },

    getPromise: () => loadPromise,
    setPromise: (promise) => { loadPromise = promise; },

    clear: () => {
        cachedEquipment = null;
        isLoading = false;
        loadPromise = null;
    }
};
